import React, { useState, useEffect } from 'react';
import '../../styles/auth.css';
import { useNavigate } from "react-router-dom";
import { t } from '../../services/translationService';
import { ApplicantLoginT } from '../../services/LanguageTranslationService';
import ReCAPTCHA from 'react-google-recaptcha';
const ApplicantLogin = ({ onClose, onSwitchToRegister, handleForgotPasswordClick }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });

  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [apiMessage, setApiMessage] = useState({ text: '', isError: false });
  const [showInstructions, setShowInstructions] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  // ESC key handler
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === 'Escape' && !isLoading && !apiMessage.text) onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose, isLoading, apiMessage]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };


  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    console.log("Captcha value:", value);
  };


  const validate = () => {
    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = ApplicantLoginT('login.errors.usernameRequired');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.username)) {
      newErrors.username = ApplicantLoginT('login.errors.validEmail');
    }

    if (!formData.password) {
      newErrors.password = ApplicantLoginT('login.errors.passwordRequired');
    } else if (formData.password.length < 6) {
      newErrors.password = ApplicantLoginT('login.errors.passwordLength');
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //if (!captchaValue) {
    //  alert('Please complete the CAPTCHA');
    //  return;
    //}
    if (!validate()) return;

    setIsLoading(true);
    setApiMessage({ text: '', isError: false });

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/login_applicant.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
        credentials: "include",
      });

      console.log("response : ", response);

      const result = await response.json();

      console.log("result : ", result);

      if (!response.ok) {
        throw new Error(result.message || ApplicantLoginT('login.errors.loginFailed'));
      }

      if (result.status === "success") {
        localStorage.setItem("token", result.token);

        setApiMessage({
          text: ApplicantLoginT('login.successMessage'),
          isError: false
        });

        setTimeout(() => {
          onClose();
          if (result.redirect) {
            navigate(result.redirect);
          }
        }, 1500);
      } else {
        throw new Error(result.message || ApplicantLoginT('login.errors.invalidCredentials'));
      }
    } catch (error) {
      setApiMessage({
        text: error.message,
        isError: true
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container" onClick={(e) => e.target === e.currentTarget && !isLoading && !apiMessage.text && onClose()}>
      <div className="auth-box">
        <div className="auth-header">
          <div className="info-icon-container">
            <button
              className="info-icon-button"
              onClick={() => setShowInstructions(true)}
              type="button"
              aria-label="Show instructions"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
              </svg>
            </button>
          </div>
          <h2 className="auth-title">{t('login.title')}</h2>
          <div className="auth-tabs">
            <button
              className="auth-tab active"
              disabled={isLoading || apiMessage.text}
            >
              {t('login.tabLogin')}
            </button>
            <button
              className="auth-tab"
              onClick={onSwitchToRegister}
              type="button"
              disabled={isLoading || apiMessage.text}
            >
              {t('login.tabRegister')}
            </button>
          </div>
          <button
            className="close-button"
            onClick={onClose}
            aria-label={t('login.closeButton')}
            disabled={isLoading || (apiMessage.text && !apiMessage.isError)}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {apiMessage.text && (
            <div className={`${apiMessage.isError ? 'error-message' : 'success-message'}`} style={{ textAlign: 'center', marginBottom: '1rem' }}>
              {apiMessage.isError ? (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                  </svg>
                  <span>{apiMessage.text}</span>
                </>
              ) : (
                <>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                  </svg>
                  <span>{apiMessage.text}</span>
                </>
              )}
            </div>
          )}

          <div className={`form-group ${errors.username ? 'error' : ''}`}>
            <label htmlFor="username">{ApplicantLoginT('login.emailLabel')}</label>
            <input
              type="email"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder={t('login.emailPlaceholder')}
              autoComplete="username"
              disabled={isLoading || (apiMessage.text && !apiMessage.isError)}
            />
            {errors.username && <span className="error-message">{errors.username}</span>}
          </div>

          <div className={`form-group ${errors.password ? 'error' : ''}`}>
            <label htmlFor="password">{ApplicantLoginT('login.passwordLabel')}</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder={ApplicantLoginT('login.passwordPlaceholder')}
              autoComplete="current-password"
              disabled={isLoading || (apiMessage.text && !apiMessage.isError)}
            />
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          {/* reCAPTCHA Widget
          <ReCAPTCHA
            sitekey='6LfYwAsrAAAAAKwbAzAomjZoUhEXXx3EDBmIqyht'
            onChange={handleCaptchaChange}
          />
 */}
          <div className="auth-buttons">
            <button
              type="submit"
              className={`submit-button ${isLoading ? 'loading' : ''}`}
              disabled={isLoading || (apiMessage.text && !apiMessage.isError)}
            >
              {isLoading ? (
                <>

                  {ApplicantLoginT('login.loggingIn')}
                </>
              ) : (
                ApplicantLoginT('login.loginButton')
              )}
            </button>
            <button
              type="button"
              className="cancel-button"
              onClick={onClose}
              disabled={isLoading || (apiMessage.text && !apiMessage.isError)}
            >
              {ApplicantLoginT('login.cancelButton')}
            </button>
          </div>


          <div className="auth-links">
            {/* 
            <a
              href="#forgot-password"
              className="forgot-password"
              onClick={handleForgotPasswordClick}
              style={{ pointerEvents: isLoading || (apiMessage.text && !apiMessage.isError) ? 'none' : 'auto' }}
            >
              {ApplicantLoginT('login.forgotPassword')}
            </a>
            */}
          </div>
        </form>

      </div>
      {showInstructions && (
        <div className="instructions-modal-overlay" onClick={() => setShowInstructions(false)}>
          <div className="instructions-modal" onClick={(e) => e.stopPropagation()}>
            <div className="instructions-modal-header">
              <h3>{ApplicantLoginT('login.instructionsTitle')}</h3>
              <button
                className="close-button"
                onClick={() => setShowInstructions(false)}
                aria-label="Close instructions"
              >
                ×
              </button>
            </div>
            <div className="instructions-modal-content">
              <p>{ApplicantLoginT('login.instruction1')}</p>
              <p>{ApplicantLoginT('login.instruction2')}</p>
              <p>{ApplicantLoginT('login.instruction3')}</p>
              <p>{ApplicantLoginT('login.instruction4')}</p>
            </div>
            <div className="instructions-modal-footer">
              <button
                className="submit-button"
                onClick={() => setShowInstructions(false)}
              >
                {ApplicantLoginT('login.okButton')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApplicantLogin;